import { render } from "./LoginFormPassword.vue?vue&type=template&id=68a0a5ca&scoped=true"
import script from "./LoginFormPassword.vue?vue&type=script&lang=js"
export * from "./LoginFormPassword.vue?vue&type=script&lang=js"

import "./LoginFormPassword.vue?vue&type=style&index=0&id=68a0a5ca&lang=scss&scoped=true"
import "./LoginFormPassword.vue?vue&type=style&index=1&id=68a0a5ca&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a0a5ca"]])

export default __exports__